import { UserAdvertisementsResponse } from 'core'

import { Alert, Button, Modal } from 'common/components'

import MarketplaceModalLogo from '../../../../../assets/images/MarketplaceModalLogo.svg'

export type AdvertisementModalProps = {
  advertisement: UserAdvertisementsResponse
  showModal: boolean
  onClose: () => void
}

function AdvertisementModal({ advertisement, showModal, onClose }: AdvertisementModalProps) {
  const modalFooter = (
    <div>
      <Button className="mr-8" onClick={onClose}>
        Cancel
      </Button>
      <a href={advertisement.siteUrl} target={'_blank'} rel="noreferrer">
        <Button type="primary" icon="fas fa-external-link" iconPosition="right">
          Continue to {advertisement.name}
        </Button>
      </a>
    </div>
  )
  return (
    <Modal visible={showModal} title="Shop Healthcare Products" footer={modalFooter} onCancel={onClose}>
      <div>
        <div className="mb-16">
          <img src={advertisement.partnershipImage} alt="store" className="w-100" />
        </div>
        <div className="font-20 text-semi-bold color-gray-9 mb-16">Leaving the PeopleKeep site...</div>
        <div className="color-gray-9 mb-16">{advertisement.description}</div>

        {/*<Alert*/}
        {/*  type="info"*/}
        {/*  message={*/}
        {/*    <div className="color-gray-9">*/}
        {/*      Get {advertisement.discount}% off your next purchase on {advertisement.name}. Code:{' '}*/}
        {/*      <span className="text-semi-bold">{advertisement.discountCode}</span>*/}
        {/*    </div>*/}
        {/*  }*/}
        {/*/>*/}
      </div>
    </Modal>
  )
}

export default AdvertisementModal
